export const BETSLIP_SUMMARY_NUMPAD = 'BETSLIP_SUMMARY_NUMPAD';
export const BETSLIP_LINEAR_NUMPAD = 'BETSLIP_LINEAR_NUMPAD';
export const QUICK_BET_NUMPAD = 'QB_NUMPAD';

export interface IStake {
    stake: number | null;
    actualStake: string | null;
}
